import loadMobileMenu from './mobileMenu'
import loadScrollEvents from './scrollEvents'
import 'flickity'
import loadFloorPlans from './floorPlan'
import loadImageGalleries from './imageGallery'
import loadExperienceMenu from './experienceMenu'
import loadResponsiveImages from './responsiveImages'
import loadEmployment from './employment'

document.addEventListener('DOMContentLoaded', () => {
    loadMobileMenu()
    loadImageGalleries()
    loadFloorPlans()
    loadScrollEvents()
    loadExperienceMenu()
    loadResponsiveImages()
    loadEmployment()
})



// WEBPACK FOOTER //
// ./js/main.js